import { render, staticRenderFns } from "./blacklist-form-modal.vue?vue&type=template&id=91792232&"
import script from "./blacklist-form-modal.vue?vue&type=script&lang=js&"
export * from "./blacklist-form-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports